import React, { useState } from 'react';
import CreditService from '../services/creditService';
import './css/OrgSetupWizard.css';

const CheckIcon = () => <span style={{fontSize:'0.7rem'}}>&#10003;</span>;

const OrgSetupWizard = ({ onClose, onComplete }) => {
  const [step, setStep] = useState(1);
  const [orgName, setOrgName] = useState('');
  const [orgDomain, setOrgDomain] = useState('');
  const [planType, setPlanType] = useState('free_trial');
  const [trialDays, setTrialDays] = useState('14');

  const [userEmail, setUserEmail] = useState('');
  const [credits, setCredits] = useState('');
  const [orgId, setOrgId] = useState(null);
  const [loading, setLoading] = useState(false);

  const next = async () => {
    try {
      if (step === 1) {
        // Create org
        if (!orgName) return;
        setLoading(true);
        const payload = { name: orgName, domain: orgDomain, subscriptionType: planType };
        if (planType === 'free_trial') payload.trialDays = parseInt(trialDays, 10);
        const result = await CreditService.createOrganization(payload);
        const newId = result?.organization?.id;
        setOrgId(newId);
        setLoading(false);
        setStep(2);
      } else if (step === 2) {
        // Add user (optional)
        if (userEmail) {
          setLoading(true);
          await CreditService.addUserToOrganization(orgId, userEmail, 'member');
          setLoading(false);
        }
        setStep(3);
      } else if (step === 3) {
        // Add credits (optional)
        if (credits) {
          setLoading(true);
          await CreditService.addCredits(orgId, parseInt(credits, 10));
          setLoading(false);
        }
        if (onComplete) onComplete();
        onClose();
      }
    } catch (err) {
      alert(err.message || 'Something went wrong');
      setLoading(false);
    }
  };

  const back = () => {
    if (step > 1) setStep(step - 1);
  };

  const steps = [
    'Organization',
    'First User',
    'Initial Credits'
  ];

  return (
    <div className="wizard-overlay">
      <div className="wizard-modal card">
        <button className="close-btn" onClick={onClose}>✕</button>
        <div className="steps">
          {steps.map((label, idx) => (
            <div key={idx} className={`step-circle ${step === idx+1 ? 'active' : idx+1 < step ? 'done' : ''}`}>
              {idx+1 < step ? <CheckIcon/> : idx+1}
            </div>
          ))}
        </div>

        {step === 1 && (
          <>
            <h2>Create Organization</h2>
            <label>
              Name
              <input value={orgName} onChange={(e) => setOrgName(e.target.value)} />
            </label>
            <label>
              Domain
              <input value={orgDomain} onChange={(e) => setOrgDomain(e.target.value)} />
            </label>
            <label>
              Plan
              <select value={planType} onChange={(e) => setPlanType(e.target.value)}>
                <option value="free_trial">Free Trial</option>
                <option value="paid">Paid</option>
              </select>
            </label>
            {planType === 'free_trial' && (
              <label>
                Trial Days
                <input type="number" min="1" value={trialDays} onChange={(e) => setTrialDays(e.target.value)} />
              </label>
            )}
          </>
        )}
        {step === 2 && (
          <>
            <h2>Add First User</h2>
            <p>You can skip and add later.</p>
            <label>
              User Email
              <input type="email" value={userEmail} onChange={(e) => setUserEmail(e.target.value)} />
            </label>
          </>
        )}
        {step === 3 && (
          <>
            <h2>Initial Credits</h2>
            <p>You can skip and manage credits later.</p>
            <label>
              Credits to Allocate
              <input type="number" min="1" value={credits} onChange={(e) => setCredits(e.target.value)} />
            </label>
          </>
        )}
        <div className="wizard-actions">
          {step > 1 && <button onClick={back} disabled={loading}>Back</button>}
          <button className="primary" onClick={next} disabled={loading || (step===1 && !orgName)}>{step === 3 ? 'Finish' : 'Next'}</button>
          {loading && <div className="loading-overlay"><div className="spinner"></div></div>}
        </div>
      </div>
    </div>
  );
};

export default OrgSetupWizard; 